import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import Scrollable from "../../Shared/Edit/Scrollable";
import ComponentToolbar from "./ComponentToolbar/ComponentToolbar";
import { useEffect, useState } from "react";
import { ATTRIBUTE_PLURAL_LABEL } from "../../Helpers/Labels/AttributeLabel";
import { useAttributes, useChangeBooleans, useResetAttributeTable, useResetComponentProperties, useSaveComponent, useUpdateSyncComponentAttributes } from "../../../Hooks/Display/useComponentProperties";
import AttributeTable from "../AttributeTable/AttributeTable";
import { useSelectedPage, useUpdatePageComponent } from "../../../Hooks/Display/usePages";
import { useSelectedComponent } from "../../../Hooks/Display/useComponents";
import { usePropsStoreValue } from "../../../Hooks/PropStore/usePropsStore";
import { useTranslation } from "react-i18next";

function Summary() {

    const [tabSelected, setTabSelected] = useState(0);

    const selectedPage = useSelectedPage();
    const selectedComponent = useSelectedComponent();
    const accessedFromDesigner = usePropsStoreValue("accessedFromDesigner");
    const updateSyncedComponentAttributes = useUpdateSyncComponentAttributes();
    const resetContext = useResetComponentProperties();
    const [{ isSyncedComponentsChanged }] = useAttributes();
    const saveComponent = useSaveComponent();
    const updatePageComponent = useUpdatePageComponent(selectedPage.parentId, selectedPage._id)
    const resetAttributes = useResetAttributeTable();

    const [{ isAttributeTableChanged }] = useChangeBooleans();

    const { t } = useTranslation([
        "display/component_toolbar",
        "display/common",
        "display/tables/attribute"
    ], { useSuspense: false })

    // componentWillUnmount
    useEffect(() => {
        return () => {
            resetContext();
        }
    }, [])

    function handleTabSelect(e) {
        setTabSelected(e.selected);
    }

    async function handleSave() {
        const updatedComponent = await saveComponent();
        updatePageComponent(selectedComponent.id, updatedComponent);
        if (
            (isAttributeTableChanged && selectedComponent.componentsToSync && selectedComponent.componentsToSync.length > 0) ||
            isSyncedComponentsChanged
        ) {
            updateSyncedComponentAttributes();
        }
    }

    function resetComponent() {
        if (isAttributeTableChanged) {
            resetAttributes();
        }
    }

    return (
        <div className={"h-100 d-flex flex-column line" + (!accessedFromDesigner && " runtimePopup")}>
            <ComponentToolbar onSave={handleSave} onReset={resetComponent} />
            <Scrollable noPadding={true}>
                <TabStrip className="flex-grow-1 h-100 edit1" selected={tabSelected} onSelect={handleTabSelect}>
                    <TabStripTab title={t("tabs.properties", { ns: "display/common" })}>
                        <AttributeTable />
                    </TabStripTab>
                </TabStrip>
            </Scrollable>
        </div>
    )
}

export default Summary;